export const SOLICITANTE = 'solicitante';
export const MEDICO = 'medico';
export const OUTRO_MEDICO = 'outroMedico';
export const INSTITUICAO = 'instituicao';